import { Button, ButtonProps } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import React from "react";

interface ThreeDotsActiveButtonProps extends ButtonProps {
  active?: boolean;
}

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

const Dot = styled("span")(({ theme }) => ({
  display: "inline-block",
  width: 6,
  height: 6,
  margin: "0 2px",
  borderRadius: "50%",
  backgroundColor: theme.palette.text.primary, // dark against light backgrounds
  animation: `${bounce} 1.4s infinite ease-in-out both`,
}));

const Dot1 = styled(Dot)({ animationDelay: "0s" });
const Dot2 = styled(Dot)({ animationDelay: "0.2s" });
const Dot3 = styled(Dot)({ animationDelay: "0.4s" });

export default function ThreeDotsActiveButton({
  active = false,
  children,
  ...props
}: ThreeDotsActiveButtonProps) {
  return (
    <Button
      {...props}
      sx={{
        position: "relative",
        "&.Mui-disabled": {
          backgroundColor: "#DCDADB !important",
        },
        ...props.sx,
      }}
    >
      {active && (
        <span
          style={{
            display: "inline-flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Dot1 />
          <Dot2 />
          <Dot3 />
        </span>
      )}
      <div style={active ? { visibility: "hidden" } : {}}>{children}</div>
    </Button>
  );
}
